import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { PriorityImage } from '@swf/poker';

import type { GameTypeName, GameTypeUrl } from '../../../types/Game';
import { DEFAULT_PROMO_IMAGE, getBackground } from '../../../utils/assets';
import styles from '../shared.scss';

export interface BackgroundProps {
  winUpTo: string;
  gameType: GameTypeName;
  isUltra: boolean;
  url: GameTypeUrl;
  promoRef: string;
}

const Background: React.FC<BackgroundProps> = ({ winUpTo, gameType, isUltra, url, promoRef }) => {
  const locale = useSelector(select.locale.get);
  const asset = React.useMemo(
    () => getBackground(url, gameType, isUltra, locale, promoRef),
    [promoRef, url, gameType, locale, isUltra]
  );

  return (
    <picture className={styles.bgr}>
      <PriorityImage
        imageUrl={asset}
        fallbackUrl={DEFAULT_PROMO_IMAGE[gameType]}
        altText={`Poker tile background for ${gameType} game where you can win up to ${winUpTo}`}
        fetchPriority="high"
      />
    </picture>
  );
};

export default Background;
